import React from 'react';
import { connect } from 'react-redux';
import EditPaymentForm from '../../../../Components/Forms/Admin/Payments/EditPayment';
import ModalsWrappedForm from '../../../../Components/Forms/ModalsWrappedForm';
import trans from '../../../../Translations/translation.service';
import { actions as allAccountsActions } from '../../../../Redux/Api/AllAccounts';
import { actions as allBanksActions } from '../../../../Redux/Api/AllBanks';
import { actions as paymentsActions, types } from '../../../../Redux/Api/Payments';
import { actions as fileUploadActions } from '../../../../Redux/Ducks/FileUpload';
import { PRIVATE_PATHS } from '../../../config';
import { PAYMENTS_URL, MALE_CODE, JSON_HEADERS as headers } from '../../../../Constants';
import {
  EDIT_ACTIONS,
  PAYMENT_PARSE_CONFIG,
} from '../../../../Components/Forms/Admin/Payments/config';
import { catchApiItemErrors, parseDataForApi } from '../../../../Helpers';

class EditPayment extends React.Component {
  getPayment = () => {
    const { id } = this.props.match.params;

    this.props.getPayment(id);
  };

  loading = () => {
    const {
      isFetchingPayment,
      isFetchingAccounts,
      isFetchingBanks,
      isUpdatingPayment,
      isUploadingFile,
    } = this.props;
    return isFetchingPayment
      || isFetchingAccounts
      || isFetchingBanks
      || isUpdatingPayment
      || isUploadingFile;
  };

  openSuccessModal = () => {
    const { fileUploadSuccess, success } = this.props;

    return success || fileUploadSuccess;
  };

  parseAccounts = () => (
    this.props.accounts.map(({ id: value, company_name: text }) => ({
      text, value,
    }))
  );

  parseBanks = () => (
    this.props.banks.map(({ id: value, name: text }) => ({
      text, value,
    }))
  );

  updatePayment = ({ transaction_src_file, contacts, ...data }) => {
    const { id } = data;

    return this.props.updatePayment(
        parseDataForApi(data, PAYMENT_PARSE_CONFIG)
      )
      .then(async res => {
        if (transaction_src_file) {
          await this.uploadContactsFile(id, transaction_src_file);
        }
      })
      .catch(
        catchApiItemErrors,
      );
  };

  uploadContactsFile = (id, transaction_src_file) => (
    this.props.uploadFile(
      `${PAYMENTS_URL}/${id}`,
      {
        transaction_src_file,
        transaction_src_file_name: transaction_src_file.name,
      },
      {
        headers,
      },
    )
  );

  componentDidMount() {
    this.getPayment();
    this.props.fetchAllAccounts();
    this.props.fetchAllBanks();
    this.props.uploadFileReset();
  }

  render() {
    const { payment, history } = this.props;
    const accounts = this.parseAccounts();
    const banks = this.parseBanks();
    const subject = trans('resources.singular.payment');

    return (
      <ModalsWrappedForm
        gender={MALE_CODE}
        history={history}
        loading={this.loading()}
        open={this.openSuccessModal()}
        path={PRIVATE_PATHS.adminPayments.path}
        subject={subject}
        successMessage="successOpSingM"
        type="edit"
      >
        {
          payment &&
          <EditPaymentForm
            actions={EDIT_ACTIONS}
            data={{
              account_id: accounts,
              bank_id: banks,
            }}
            history={history}
            onSubmit={this.updatePayment}
            path={PRIVATE_PATHS.adminPayments.path}
          />
        }
      </ModalsWrappedForm>
    );
  }
}

const mapStateToProps = ({
  allAccounts: {
    isFetching: isFetchingAccounts,
    items: accounts,
  },
  allBanks: {
    items,
    isFetching: isFetchingBanks,
  },
  payments: { isFetchingItem, isUpdating, item },
  fileUpload: { pending, response, success: fileUploadSuccess },
  reduxRestResponse: { body, success, type },
  ...state
}) => ({
  body,
  isFetchingAccounts,
  isFetchingBanks,
  response,
  fileUploadSuccess,
  payment: item,
  accounts: accounts[1] ? accounts[1] : [],
  banks: items[1] ? items[1] : [],
  isFetchingPayment: isFetchingItem,
  isUpdatingPayment: isUpdating,
  isUploadingFile: pending,
  success: type === types.UPDATE_PAYMENT && success,
});
export default connect(
  mapStateToProps,
  {
    ...allAccountsActions,
    ...allBanksActions,
    ...paymentsActions,
    ...fileUploadActions,
  }
)(EditPayment);
